import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Link } from "react-router-dom";
// import AppBar from '@mui/material/AppBar';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
// import Container from '@mui/material/Container';
// import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
// import AdbIcon from '@mui/icons-material/Adb';








// import MuiAppBar from '@mui/material/AppBar';
// import CssBaseline from '@mui/material/CssBaseline';
// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import MailIcon from '@mui/icons-material/Mail';
// import Link from '@mui/material/Link';

import logo from '../../../../assests/logo.jpg';

//Banks
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
//Inspector
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
//Builder
import ConstructionIcon from '@mui/icons-material/Construction';
// import AddIcon from '@mui/icons-material/Add';
import GiteIcon from '@mui/icons-material/Gite';
import EngineeringIcon from '@mui/icons-material/Engineering';




import { log_out_user } from '../../../../Redux/User/ReduxSliceUser';



const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== 'open',
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(['width', 'margin'], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(['width', 'margin'], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main:'#1976d2'
      },
      dark:{
        main:'#000000'
      }
    },
  });

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default function SideBarNav() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    // const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);


    // const[viewingComponent,setViewingComponent] = React.useState("addBank");

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userSelected = useSelector((state) => state.user);

    const userFullName = userSelected.userValue.user.first_name + userSelected.userValue.last_name

  
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const logoutUser = () =>{
        dispatch(log_out_user())
        navigate("/")
    }


  const settings = [ 
    {wording:'Logout',action:logoutUser}

    ]; //'Profile', 'Account', 'Dashboard',

 

  return (
    <>
        <Box sx={{ display: 'flex' }}>
            <ThemeProvider theme={darkTheme}>
                {/* <CssBaseline /> */}
                <Drawer variant="permanent" open={open} sx={{backgroundColor:'black'}}>
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        href="#app-bar-with-responsive-menu"
                        sx={{
                        fontFamily: 'monospace',
                        fontWeight: 700,
                        letterSpacing: '.3rem',
                        color: 'inherit',
                        textDecoration: 'none',
                        backgroundColor:'black'
                        }}
                    >
                        <img src={logo} style={{height:'8vh', width:'8vh'}} alt='select inspections'></img>
                    </Typography>
                    <Toolbar sx={{backgroundColor:'black',color:'white'}}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            sx={{
                            marginRight: 5,
                            color:'white',
                            ...(open && { display: 'none' }),
                            }}
                        >
                            <MenuIcon sx={{backgroundColor:'black',color:'white'}} />
                        </IconButton>
                        <Typography variant="h6" noWrap component="div" sx={{backgroundColor:'black',color:'white'}}>
                            Select Inspection
                        </Typography>
                    </Toolbar>
                    <DrawerHeader sx={{backgroundColor:'black',color:'white', display:open === false ? 'none':'auto'}}>
                    <IconButton onClick={handleDrawerClose} sx={{backgroundColor:'black'}}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon sx={{color:'white'}} />}
                    </IconButton>
                    </DrawerHeader>
                    {/* <Divider /> */}
                    <List id="bankList" sx={{backgroundColor:'black'}}>
                        <ListItem key={'AddUpdateBank'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/AddUpdateBank' style={{textDecoration:'none'}}> 
                            {/*   /AddBankPage */}
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <AttachMoneyIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Bank'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                </ListItemButton> 
                            </Link> 
                        </ListItem>
                        <ListItem key={'AddUpdateBankBranch'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/BankBranchTabsPage' style={{textDecoration:'none'}}> 
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <AccountBalanceIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Bank Branch'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                </ListItemButton> 
                            </Link> 
                        </ListItem>
                        <ListItem key={'AddBankEmployee'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/AddUpdateBankEmployeePage' style={{textDecoration:'none'}}>
                            {/*  /AddBankEmployeePage*/}
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <PlaylistAddCircleIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Bank Employee'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                    
                                </ListItemButton>
                            </Link>
                        </ListItem>
                    </List>
                    <Divider sx={{color:'white', backgroundColor:'white'}} />
                    <List id="InspectersList" sx={{backgroundColor:'black'}}>
                        <ListItem key={'Add_Inspection_Agency'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/AddUpdateInspectionHQ' style={{textDecoration:'none'}}>
                            {/*    /AddInspectingBusiness*/}
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <ContentPasteIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Inspection Agency'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                </ListItemButton>    
                            </Link> 
                        </ListItem>

                        <ListItem key={'Add_Inspection_Agency_Branch'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/AddUpdateinspectionBranch' style={{textDecoration:'none'}}>
                            {/*    /AddInspectingBusiness*/}
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <MapsHomeWorkIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Inspection Agency'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                </ListItemButton>    
                            </Link> 
                        </ListItem>


                        

                        <ListItem key={'Add_Inspector'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/AddUpdateinspectionAgencyEE' style={{textDecoration:'none'}}>
                            {/*     /AddInspector */}
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <PersonAddAltIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Inspector'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                </ListItemButton>
                            </Link> 
                        </ListItem>


                        
                    </List>
                    <Divider sx={{color:'white', backgroundColor:'white'}} />
                    <List id="builderList" sx={{backgroundColor:'black'}}>
                        <ListItem key={'Add_Builder_Agency'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/AddUpdateBuilderHQ' style={{textDecoration:'none'}}>
                            {/*     /AddBuilderBusinessPage */}
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <ConstructionIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Builder Agency'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                    
                                </ListItemButton>
                            </Link>
                        </ListItem>

                        <ListItem key={'Add_Builder_Agency_Branch'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/AddUpdateBuilderBranch' style={{textDecoration:'none'}}>
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <GiteIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Builder Agency'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                    
                                </ListItemButton>
                            </Link>
                        </ListItem>
                        
                        <ListItem key={'Add_Builder_Employee'} disablePadding sx={{ display: 'block' }}>
                            <Link to='/AddUpdateBuilderEE' style={{textDecoration:'none'}}>
                            {/*     /AddBuilderEmployeePage */}
                                <ListItemButton
                                    sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    }}
                                >
                                    <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                        color:'white'
                                    }}
                                    >
                                        <EngineeringIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary={'Add Builder Employee'} sx={{color:'white', opacity: open ? 1 : 0 }} />
                                </ListItemButton>
                            </Link>
                        </ListItem>
                    </List>

                    <Box sx={{mt:"10vh"}}>
                        <Divider sx={{color:'white', backgroundColor:'white'}} />
                        {/* <Container> */}
                        <Box sx={{mt:"2vh"}}>
                            <Box sx={{ flexGrow: 0 }}>
                                <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar alt={String(userFullName)} src="/static/images/avatar/2.jpg" />
                                </IconButton>
                                </Tooltip>
                                <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                                >
                                {settings.map((setting) => (
                                    <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                    <Typography textAlign="center" onClick={(e)=>{setting.action()}}>{setting.wording}</Typography>
                                    </MenuItem>
                                ))}
                                </Menu>
                            </Box>

                        </Box>

                    </Box>
                        
                    {/* </Container> */}

                </Drawer>
            </ThemeProvider>
            {/* <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <DrawerHeader /> 
                 {
                    viewingComponent === 'addBank' ?
                        <AddBankPage/>
                    :
                        <div>idk</div>
                } 
                
            </Box> */}
        </Box>
    </>
  );
}

